// src/components/FileUploader.js
import React from 'react';

function FileUploader({ label, onFileSelected }) {
  // Triggered when user selects a file
  const handleFileChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      onFileSelected(event.target.files[0]); 
    }
  };

  return (
    <div style={{ marginBottom: '1rem' }}>
      <label>{label}</label>
      <br />
      <input
        type="file"
        onChange={handleFileChange}
        style={{ marginTop: '8px' }}
      />
    </div>
  );
}

export default FileUploader;
